import type { NavigateFunction } from 'react-router-dom'

import { createRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface Value {
  navigate: NavigateFunction
}

export let navigationRef = createRef<Value>()

export function NavigationSetter (): JSX.Element | null {
  let navigate = useNavigate()

  useEffect(() => {
    // @ts-expect-error // It's fine, I guess
    navigationRef.current = { navigate }
  }, [ navigate ])

  return null
}
